import styled from 'styled-components'

import Game from '~/shared/assets/images/game.png'
import Illust from '~/shared/assets/images/illust.png'
import Music from '~/shared/assets/images/music.png'
import Novel from '~/shared/assets/images/novel.png'
import theme from '~/shared/styles/theme'

function DonginMarketIntroduction() {
  return (
    <Wrapper>
      <Row>
        <Image src={Illust} alt="일러스트" />
        <Image src={Music} alt="음악" />
        <Image src={Novel} alt="소설" />
        <Image src={Game} alt="게임" />
      </Row>
      <Row>
        <Description>일러스트</Description>
        <Description>음악</Description>
        <Description>소설</Description>
        <Description>게임</Description>
      </Row>
    </Wrapper>
  )
}

export default DonginMarketIntroduction

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px; /* 첫 번째 행과 두 번째 행 사이의 간격 */
`

const Row = styled.div`
  display: flex;
  gap: 35px; /* 각 열 사이의 간격 */
  justify-content: space-between;

  @media ${theme.device.medium} {
    gap: 0; /* 모바일에서 겹치게 하기 위해 gap 제거 */
  }
`

const Image = styled.img`
  width: 104px;
  height: 104px;
  border-radius: 50%; /* 이미지를 구체로 만듦 */

  @media ${theme.device.medium} {
    position: relative;
    margin-left: -10%; /* 각 구체가 10%씩 겹치도록 설정 */
    &:first-child {
      margin-left: 0; /* 첫 번째 이미지는 왼쪽으로 이동하지 않도록 설정 */
    }
  }
`

const Description = styled.div`
  flex: 1; /* 각 텍스트를 균등하게 분배 */

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 20px;
  font-weight: 500;
  text-align: center; /* 텍스트를 가운데 정렬 */
`
